<template>
    <div class="changepwd_main_container">
        <div class="bg_box">
            <div class="changepwd_box">
                <div class="changepwd_title">
                    <div class="title gray size-30">
                        {{ titleLabel }}
                    </div>
                </div>
                <div class="changepwd_form">
                    <reset-form
                        :user="user"
                        :loading="loading"
                        @reset="reset"
                    ></reset-form>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResetForm from '../../components/form/ResetForm.vue'
import { token, postRequest } from "../../utils/api";
export default {
    data(){
        return{
            loading : false,
            user: {
                loginid: "",
                password: "",
                repasswd: "",
                captcha: "",
                langcode: "",
                logintype: "0",
                token: "",
            },
            url: "",
            titleLabel: this.$t("changePassword_pageText.RESETPWD"),
            checksession: true,
        };
    },
    mounted() {
        this.init();
    },
    components: {
        ResetForm
    },
    computed: {
        ...mapGetters("user", ["hrid", "language"])
    },
    methods:{
        changeLang(lang) {
            this.$i18n.locale = lang;
        },
        init() {
            this.changeLang(this.language);
            this.user.loginid = this.hrid;
        },
        reset(){
            let _this = this;
            //console.log('111');
            let isforget = _this.$cookies.get("isforget");
            let isfirst = _this.$cookies.get("isfirst");
            _this.isLogining = true;
            _this.user.langcode = this.$i18n.locale;
            if(isforget=='1'){     
                _this.repwdHandle(_this.user)
                .then(res => {
                let message = res.message;
                if (res.success) {   
                    _this.$alert(_this.$t("Password changed successfully"), {
                        confirmButtonText: _this.$t("changePassword_pageText.CONFIRM"),
                        type:'success'
                    }).then(()=>{ 
                        //console.log('444');
                        _this.logout();
                        //_this.$router.replace("/login?langcode=" + this.$i18n.locale);
                    });     
                } else {
                    if(message=="Verification code error.") _this.$message.error(_this.$t("warning_pageText.VERCODE_ERROR"));
                    else if(message.length<60)
                    _this.$message.error(_this.$t("warning_pageText.RESETFAILED_NOTMEET"));
                    else _this.$message.error(_this.$t("warning_pageText.RESETFAILED_NOTDIFF"));
                
                }
                })
                .catch(error => {
                    //console.log('2222');
                    _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
                }); 
            }else{
                 _this.checkSession();
                if(_this.checksession){ 
                    _this.repwdHandle(_this.user)
                        .then(res => {
                        let message = res.message;
                        if (res.success) { 
                            if(isfirst=='1'){
                                _this.$alert(_this.$t("changePassword_pageText.SUCC_TIP"), {
                                confirmButtonText: _this.$t("changePassword_pageText.CONFIRM"),
                                type:'success'
                                }).then(()=>{
                                    _this.logout();
                                    //_this.$router.replace("/login?langcode=" + this.$i18n.locale); 
                                }); 
                            }else{
                                _this.$alert(_this.$t("Password changed successfully"), {
                                    confirmButtonText: _this.$t("changePassword_pageText.CONFIRM"),
                                    type:'success'
                                }).then(()=>{ 
                                    _this.$router.replace("/"); 
                                });
                            }    
                        } else {
                            if(message=="Verification code error.") _this.$message.error(_this.$t("warning_pageText.VERCODE_ERROR"));
                            else if(message.length<60)
                            _this.$message.error(_this.$t("warning_pageText.RESETFAILED_NOTMEET"));
                            else _this.$message.error(_this.$t("warning_pageText.RESETFAILED_NOTDIFF"));
                        
                        }
                        })
                        .catch(error => {
                            _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
                        });
                }
            }
        },
        repwdHandle(user) {
            //console.log('333');
            return new Promise((resolve, reject) => {
                postRequest("changePassword", {
                    hrid: this.$cookies.get("isforget")=='1'? this.hrid : user.loginid,
                    password: user.password,
                    //verificationcode: user.captcha
                })
                .then(res => {
                    let datas = res.data;
                    //console.log('datas');
                    resolve(datas);
                })
                .catch(error => {
                    
                    reject(error);
                });
            });
        },
        logout() {
            let _this = this;
            _this.user.loginid = _this.hrid;
            _this.user.token = token;
            _this
                .logoutHandle(_this.user)
                .then(res => {
                if (res.success) {
                   
                    _this.$store.commit("user/removeUser");
                    _this.$router.replace("/login?langcode=" + _this.$i18n.locale);
                     _this.$router.go(0);
                } else {
                    _this.$message.error(res.message);
                }
                })
                .catch(error => {
                 _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
                });
        },
        logoutHandle(user) {
            return new Promise((resolve, reject) => {
                postRequest("userLogout", {
                loginid: user.loginid,
                logintype: user.logintype,
                token: token,
                maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        checkSession(){
            let _this = this;
            return new Promise((resolve, reject) => {
                postRequest("checkSession", {
                hrid: _this.hrid,
                clienthost: sessionStorage.getItem('ip') ? sessionStorage.getItem('ip') : '127.0.0.1',
                maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
                result: sessionStorage.getItem('sessionresult') ? sessionStorage.getItem('sessionresult') : '2',
                })
                .then(res => {
                    let datas = res.data;
                    //console.log(datas);
                    //return;
                    if(!datas.success){
                    _this.checksession = false;
                    sessionStorage.setItem('sessionresult','0');
                    _this.$message.error({
                        message: (!sessionStorage.getItem("timeOutTips") || sessionStorage.getItem("timeOutTips")=='') ? 
                        'Your session has timed out. Please log in again.' : sessionStorage.getItem("timeOutTips"),
                        duration: 4000
                    });
                    setTimeout(function (){
                        _this.logout();
                    }, 3000);
                    }else{
                    sessionStorage.setItem('sessionresult','1');
                    }
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
    },
    watch: {
        "$i18n.locale"(curVal, oldVal) {
            this.titleLabel = this.$t("changePassword_pageText.RESETPWD");
        }
    }
}
</script>
<style scoped>
.changepwd_main_container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 700px; */
  height: 100%;
  /* background: url("../../assets/img/bg.png") no-repeat; */
  background-size: cover;
  overflow: hidden;
}
.bg_box {
    justify-content: center;
    /* width:100%; */
    display: flex;
    align-items: center;
}

.changepwd_title {
  padding: 10px 30px 0 30px;
  text-align: left;
}

.changepwd_title > .title {
  margin: auto;
  padding: 0 0 30px 0;
}

.changepwd_box {
  width: 700px;
  /* height: 400px; */
  background-color: #fffc;
  -webkit-box-shadow: 0 0 10px #bababa;
  box-shadow: 0 0 10px #bababa;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin: 0 auto;
  padding: 20px 10px;
  box-sizing: border-box;
}
.changepwd_form{
  margin: 0 auto;
}
</style>